(() => {
  const storageKey = 'lootsepeti-color-mode-v1';
  const fallbackModes = {
    dark: { palette: 'obsidian-red', background: '#0e0707', vars: {}, label: 'Koyu tema aktif' },
    light: { palette: 'sakura-pearl', background: '#fff2f6', vars: {}, label: 'Açık tema aktif' },
  };

  const configuredModes = window.__lootModeConfig || {};
  const modes = {
    dark: { ...fallbackModes.dark, ...(configuredModes.dark || {}), label: 'Koyu tema aktif' },
    light: { ...fallbackModes.light, ...(configuredModes.light || {}), label: 'Açık tema aktif' },
  };

  function safeStore(mode) {
    try {
      window.localStorage.setItem(storageKey, mode);
    } catch (error) {}
  }

  function swapLogos(mode) {
    document.querySelectorAll('[data-loot-mode-logo]').forEach((image) => {
      const nextSource = mode === 'light' ? image.dataset.lightSrc : image.dataset.darkSrc;
      if (nextSource && image.getAttribute('src') !== nextSource) {
        image.removeAttribute('srcset');
        image.setAttribute('src', nextSource);
      }
    });
  }

  function updateControls(mode) {
    document.querySelectorAll('[data-loot-mode-toggle]').forEach((button) => {
      const isLight = mode === 'light';
      button.setAttribute('aria-checked', String(isLight));
      button.setAttribute('aria-label', isLight ? 'Koyu temaya geç' : 'Açık temaya geç');
      button.setAttribute('title', isLight ? 'Koyu temaya geç' : 'Açık temaya geç');
      const label = button.querySelector('[data-loot-mode-label]');
      if (label) label.textContent = modes[mode].label;
    });
  }

  function applyMode(mode, persist = false) {
    const selected = modes[mode] ? mode : 'dark';
    const settings = modes[selected];
    const root = document.documentElement;
    const body = document.body;

    root.dataset.lootMode = selected;
    root.dataset.lootPalette = settings.palette;
    root.style.backgroundColor = settings.background;
    Object.entries(settings.vars || {}).forEach(([name, value]) => root.style.setProperty(name, value));

    if (body) {
      body.classList.add('loot-mode-switching');
      body.dataset.lootMode = selected;
      body.dataset.lootPalette = settings.palette;
      body.style.backgroundColor = settings.background;
      window.setTimeout(() => body.classList.remove('loot-mode-switching'), 320);
    }

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute('content', settings.background);

    swapLogos(selected);
    updateControls(selected);
    if (persist) safeStore(selected);

    document.dispatchEvent(new CustomEvent('loot:mode-change', {
      detail: { mode: selected, palette: settings.palette }
    }));
  }

  function init() {
    const initial = document.documentElement.dataset.lootMode === 'light' ? 'light' : 'dark';
    applyMode(initial, false);

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-loot-mode-toggle]');
      if (!toggle) return;
      const current = document.body?.dataset.lootMode === 'light' ? 'light' : 'dark';
      applyMode(current === 'light' ? 'dark' : 'light', true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    const current = document.body?.dataset.lootMode === 'light' ? 'light' : 'dark';
    swapLogos(current);
    updateControls(current);
  });
})();
